//Mide altura del slider y proporciona esa medida div.contenido
$(document).ready(function() {
  $('#preloader').addClass('inactivo');

  var alto = $('.area-slider'),
    cabecera = $('header'),
    medida = alto.height(),
    medidaC = cabecera.height(),
    cont = $('.contenido');

  cont.css('margin-top', medida - medidaC);

  var convenio = $('.convenios .items'),
    elancho = convenio.width();
  convenio.css('height', elancho);

  $(window).resize(function() {
    elancho = convenio.width();
    convenio.css('height', elancho);
  });

  $('.panel-collapse.in').collapse('hide');

  //Transparencia

  // function rutaURLWeb(){
  //    var sRuta = window.location.pathname;
  //    var transparencia = $('.container .area-logo');
  //    var anchoW =  $(window).width();

  //    if(sRuta !== "/" && anchoW <= 420){
  //      transparencia.hide();
  //    }

  // }

  // rutaURLWeb();

  $(function() {
    $('[data-toggle="tooltip"]').tooltip()
  })

  var valorTitulo = $('.desplegable.interior .bg-contenido .col-lg-5 h4').html(),
    bgContenido = $('header .desplegable .bg-contenido');

  if (valorTitulo == 'Transparencia Municipal') {
    bgContenido.css('overflow', 'inherit');
  }

  var tablas = $('.table');
  tablas.wrap("<div class='table-responsive'></div>");

  // Sub Menu Aside

  var ventana = $(window).width(),
    sub_menu = $('.sub-menu'),
    listado = $('.sub-menu ul');

  if (ventana <= 736) {
    sub_menu.prepend("<a class='btn btn-subMenu' href='#'>Seleccione menú</a>");
    var btnSm = $('.btn-subMenu');

    btnSm.on('click', function() {
      listado.first().toggle();
    })
  }

});

//Abrir buscador
var buscador = $('.search'),
  btn = $('.search a');

var _sform = $('.search form'); /* buscar mediante click */
btn.on('click', function(event) {
  event.preventDefault();
  var nombre = buscador.attr('class');

  if (nombre == "search") {
    buscador.addClass('open')
  } else {
    //buscador.removeClass('open')
    _sform.submit(); /* buscar mediante click */
  }
})

function scrollToAnchor(aid) {
  var aTag = $("#" + aid);
  $('html,body').animate({
    scrollTop: aTag.offset().top
  }, 'slow');
}

$(".down").click(function() {
  scrollToAnchor('1');
});

$('.up').click(function() {
  $("html, body").animate({
    scrollTop: 0
  }, 'slow');
  return false;
});

// $(".up").click(function() {
//   scrollToAnchor('top');
// });

var open = $('.open'),
  desplegable = $('.desplegable.interior'),
  submenu = $('.desplegable.interior .bg-contenido .submenu'),
  titulo = $('.desplegable.interior .bg-contenido .col-lg-4 h4'),
  titulO = $('.desplegable.interior .bg-contenido .hidden-xs'),
  imgT = $('.desplegable.interior .bg-contenido .col-lg-4 .imgTarjeta'),
  parrafo1 = $('.desplegable.interior .bg-contenido .col-lg-4 p'),
  parrafo2 = $('.desplegable.interior .bg-contenido .col-lg-8 p');

open.on('click', function() {
  var altura = $('.desplegable.interior').css("height");
  var ancho = $(window).width();

  if (altura <= '300px') {
    desplegable.animate({
      height: 95,
    });

    if (ancho <= '420') {
      open.addClass('cerrar');
      submenu.hide();
      titulO.addClass('mostrar');
      parrafo1.hide();
      parrafo2.hide();
      titulo.css("width", "100%");
      imgT.hide();
    } else {
      open.addClass('cerrar');
      submenu.hide();
      parrafo1.hide();
      parrafo2.show();
      titulo.css("width", "100%");
      imgT.hide();
    }
  } else {
    if (desplegable.attr('id') == 'servicios' && ancho <= '420') {
      desplegable.animate({
        height: 300,
      });
    } else {
      desplegable.animate({
        height: 255,
      });
    }
    open.removeClass('cerrar');
    submenu.show();
    parrafo1.show();
    parrafo2.hide();
    $('.desplegable#tarjetaV .bg-contenido .col-lg-4 h4').css("width", "188px");
    imgT.show();
    titulO.removeClass('mostrar');
  }
})

// Submenu aside left
var openM = $('aside.sub-menu ul li'),
  subM = $('aside.sub-menu ul li ul');

openM.click(function() {
  //    event.preventDefault();
  $(this).find(subM).toggle();
})

//$("#menu > li > a").click(function () {
//    $('ul.sub-menu').not($(this).siblings()).slideUp();
//    $(this).siblings("ul.sub-menu").slideToggle();
//});

$(function() {
  $("#datepicker").datepicker();
});

//Calendario DataPicker Español
$.datepicker.regional['es'] = {
  closeText: 'Cerrar',
  prevText: '< Ant',
  nextText: 'Sig >',
  currentText: 'Hoy',
  monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
  monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Juv', 'Vie', 'Sáb'],
  dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  weekHeader: 'Sm',
  dateFormat: 'dd/mm/yy',
  firstDay: 1,
  isRTL: false,
  showMonthAfterYear: false,
  yearSuffix: ''
};
$.datepicker.setDefaults($.datepicker.regional['es']);

//Convenios


//Carrousel principal home//
$('.sliderPrincipal').owlCarousel({
  animateIn: 'fadeIn',
  animateOut: 'fadeOut',
  items: 1,
  smartSpeed: 3000, //450 
  autoplay: true,
  autoplayTimeout: 7000,    
  loop: true,
  responsiveClass: true,
  center: true,    
  mouseDrag: false,
  touchDrag: false,
  pullDrag: false,    
  autoplayHoverPause: false
});

var dot = $('.sliderPrincipal .owl-nav').append('<div class="num"></div>');

//Carrousel Agenda Home/
$('.agenda').owlCarousel({
  animateIn: 'fadeIn',
  animateOut: 'fadeOut',
  items: 1,
  smartSpeed: 450,
  autoplay: true,
  loop: true,
  mouseDrag: true,
  autoplayHoverPause: false,
  nav: true,
  dots: false
});

//Carrousel Video Home/
$('.video').owlCarousel({
  animateIn: 'fadeIn',
  animateOut: 'fadeOut',
  items: 1,
  smartSpeed: 450,
  autoplay: true,
  loop: true,
  mouseDrag: true,
  autoplayHoverPause: false,
  nav: false,
  dots: true
});

//Carrousel Mas Noticias Home/
$('.noticias').owlCarousel({
  animateIn: 'fadeIn',
  animateOut: 'fadeOut',
  items: 1,
  smartSpeed: 450,
  autoplay: true,
  loop: true,
  mouseDrag: true,
  autoplayHoverPause: false,
  nav: true,
  dots: false
});

//Carrousel slider Categorias Tarjeta Vecino

$('.sliderCategoriasC').owlCarousel({
  smartSpeed: 450,
  autoplay: true,
  loop: true,
  mouseDrag: false,
  autoplayHoverPause: true,
  nav: true,
  dots: false,
  responsive: {
    0: {
      items: 3,
    },
    768: {
      items: 6,

    },
    1000: {
      items: 10,
    }
  }
});

//Carrousel interior Tarjeta Vecion//

$('.sliderDestacados').owlCarousel({
  animateIn: 'fadeIn',
  animateOut: 'fadeOut',
  items: 1,
  smartSpeed: 450,
  autoplay: true,
  loop: true,
  mouseDrag: true,
  autoplayHoverPause: false,
  nav: true
});

var dot2 = $('.sliderDestacados .owl-nav').append('<div class="num"></div>');

$('#exposicion').owlCarousel({
  animateIn: 'fadeIn',
  animateOut: 'fadeOut',
  items: 1,
  smartSpeed: 450,
  autoplay: true,
  loop: true,
  mouseDrag: true,
  autoplayHoverPause: false,
  nav: false
});

$('#carusel').owlCarousel({
  animateIn: 'fadeIn',
  animateOut: 'fadeOut',
  items: 1,
  smartSpeed: 450,
  autoplay: true,
  loop: true,
  mouseDrag: true,
  autoplayHoverPause: true,
  nav: false,
  autoplayTimeout: 9000
});

$('#consejos').owlCarousel({
  items: 1,
  smartSpeed: 450,
  autoplay: true,
  loop: true,
  mouseDrag: false,
  autoplayHoverPause: true,
  nav: true,
  dots: false
});

//Carrousel Landing Violencia/
$('.agenda.violencia').owlCarousel({ 
  animateIn: 'slideInLeft',
  animateOut: 'slideOutRight',
  center: true,
  margin: 0,
  responsiveClass:true,    
  items: 4,
  smartSpeed: 450,
  autoplay: true,
  loop: true,
  mouseDrag: false,
  touchDrag: false,
  autoplayHoverPause: false,
  nav: true,
  dots: false
});
//Carrousel Landing Vivienda/
$('.vivienda').owlCarousel({    
  center: true,
  margin: 10,
  items: 1,   
  loop: true,
  nav: true,
  dots: false,
  autoplay: false,
  mouseDrag: false,
  touchDrag: false    
});
$('.viviendaGal').owlCarousel({    
  center: true,
  margin: 10,
  items: 1,   
  loop: true,
  nav: true,
  dots: false,
  autoplay: true,
  autoplayTimeout:5000,
  mouseDrag: false,
  touchDrag: false    
});
$('.mujerGal').owlCarousel({    
  center: true,
  margin: 10,  
  loop: true,
  nav: true,
  dots: false,
  autoplay: true,
  autoplayTimeout:5000,
  mouseDrag: false,
  touchDrag: false,    
  responsiveClass:true,
  responsive:{
        320:{
            items:1,
            dots: false,
            nav:true
        },
        678:{
            items:1,
            dots: false,
            nav:true
        },
        960:{
            items:2,
            dots: false,
            nav:true
        },
        1200:{
            items:2,
            dots: false,
            nav:true
        }
    }
});
// Menu Movil

var openMovil = $('.bot-submenu'),
  menu = $('nav.principal ul#movil'),
  link = $('nav.principal ul#movil li a'), 
  sublink = $('ul.submenu li a'); 


openMovil.on('click', function() {

  if (openMovil.attr('class') === 'bot-submenu') {
    openMovil.addClass('close');
    menu.show().css('display', 'flex');
  } else {
    openMovil.removeClass('close');
    menu.show().css('display', 'none');
  }

});
//link.click(function(event){
//    event.preventDefault();
//
//});
//sublink.click(function(e){
//    $.get($(this).attr('href'), function(data){$(this).next().html(data)});
//    e.stopPropagation();
//});

//comentar las 2 funciones siguientes y la var para ver el error de == $0

function getNameURLWeb() {
  var sPath = window.location.pathname;
  var sPage = sPath.substring(sPath.lastIndexOf('/') + 1);
  return sPage;
}
var url = getNameURLWeb();
var pagina = url.replace(".html", "");


function combinarCombo(idElemnt1, idElemnt2, url_base) {
  var val1 = $('#' + idElemnt1).val(),
    val2 = $('#' + idElemnt2).val(),
    base_url = '/transparencia/' + url_base + '_' + val1 + '_' + val2 + '.html';

  if (val1 == '') {
    alert('Debe seleccionar un año');
  } else if (val2 == '') {
    alert('Debe seleccionar un mes');
  } else {
    window.location.href = base_url;
  }
}

//Transparencia

//Abrir menus transparencia

var abrirT = $('ul#sel-transparencia li a#abrirM');

abrirT.on('click', function() {
  $('ul#sel-transparencia ul').toggle();
})
